import * as React from 'react';
import SegmentCommon from './components/SegmentCommon/SegmentCommon';
import SegmentCompact from './components/SegmentCompact/SegmentCompact';
import { initI18n } from '../utils';
import { FlightClass } from '@websky/graphql';
initI18n('Segment');
const Segment = ({ variant, segment, serviceClass = FlightClass.Economy, flightNumber, footerItems, renderFooter }) => {
    return variant === 'common' ? (React.createElement(SegmentCommon, { segment: segment, serviceClass: serviceClass, flightNumber: flightNumber, footerItems: footerItems, renderFooter: renderFooter })) : (React.createElement(SegmentCompact, { segment: segment, serviceClass: serviceClass, flightNumber: flightNumber, footerItems: footerItems, renderFooter: renderFooter }));
};
export default Segment;
